import { jsx } from "react/jsx-runtime";
import { Modal } from "../private/Modal/Modal.mjs";
const defaultWidth = "small";
const modalStyle = {
  position: "center",
  headingLevel: "3"
};
const Dialog = ({ width = defaultWidth, ...restProps }) => /* @__PURE__ */ jsx(Modal, { width, ...restProps, ...modalStyle });
export {
  Dialog
};
